import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Collapse, Stack, Typography } from '@mui/material';
import currency from 'currency.js';
import { format } from 'date-fns';
import React, { useState } from 'react';

import { addCommas, calculateDollarBudget, defaultCurrencyOptions, formatServerDate, round } from '../../util/helpers';
import mapContractToForm from '../../util/mapContractToForm';

interface KPIHeaderProps {
  contract: any;
  lineItems: any;
}

export const formatImpressionBudget = (advisoryBudget, bonus) =>
  currency(advisoryBudget, defaultCurrencyOptions).add(currency(bonus, defaultCurrencyOptions)).format();

export const formatDate = (date) => (date && format(new Date(formatServerDate(date)), 'dd-MMM-yyyy')) || '--';
export const formatFlightDate = (startDate, endDate = new Date()) =>
  (startDate && endDate && `${formatDate(startDate)} to ${formatDate(endDate)}`) || '--';

function KPIHeader({ contract, lineItems }: KPIHeaderProps) {
  const [open, setOpen] = useState(false);
  const contractForm = mapContractToForm(contract);

  const { advisoryBudget, bonus, bidType, pricingRate, startDate, endDate } = contractForm;

  const contractImpressionBudget = formatImpressionBudget(advisoryBudget, bonus);

  const flightDate = formatFlightDate(startDate, endDate);

  const allocatedImpressions = lineItems?.reduce(
    (accumulator, currentValue) => accumulator + Number(currentValue.advisory_budget) + Number(currentValue.bonus),
    0
  );
  const allocatedDollars = lineItems?.reduce(
    (accumulator, currentValue) => accumulator + currentValue.dollar_budget,
    0
  );

  return (
    <>
      <Stack
        sx={{
          position: 'absolute',
          top: '1em',
          right: '1em',
        }}
        onClick={() => setOpen(!open)}
      >
        {open ? <ExpandLess /> : <ExpandMore />}
      </Stack>
      <Collapse in={open} timeout="auto" unmountOnExit={false}>
        <Stack direction="row" mt={1} spacing={2} justifyContent="space-between">
          <Stack>
            <Typography variant="h6">{addCommas(round(contractImpressionBudget))}</Typography>
            <Typography variant="caption" color="gray">
              Contract Impressions Budget
            </Typography>
          </Stack>
          <Stack>
            <Typography variant="h6">
              ${round(calculateDollarBudget(bidType, pricingRate.toString(), advisoryBudget.toString()))}
            </Typography>
            <Typography variant="caption" color="gray">
              Contract Dollar Budget
            </Typography>
          </Stack>
          <Stack>
            <Typography variant="h6">{addCommas(round(allocatedImpressions))}</Typography>
            <Typography variant="caption" color="gray">
              Allocated Impressions
            </Typography>
          </Stack>
          <Stack>
            <Typography variant="h6">${round(allocatedDollars)}</Typography>
            <Typography variant="caption" color="gray">
              Allocated Dollars
            </Typography>
          </Stack>
          <Stack>
            <Typography variant="h6">{flightDate}</Typography>
            <Typography variant="caption" color="gray">
              Flight Dates
            </Typography>
          </Stack>
        </Stack>
      </Collapse>
    </>
  );
}

export default KPIHeader;
